<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<!-- WARNING!!!! ****** DO NOT EDIT THIS FILE FOR ANY REASON OR YOU WILL BE EJECTED INTO SPACE ****** WARNING!!!!-->
<template>
    <div
        class="hb-autocomplete-wrapper"
        :class="{'hb-autocomplete-width-370' : !full && !search, 'hb-autocomplete-disabled' : disabled, 'hb-autocomplete-condensed-wrapper' : condensed}"
        :style="'width:' + computedWidth"
    >
        <v-autocomplete
            :value="value"
            @input="$emit('input', value)"
            class="ma-0 pa-0"
            v-bind="$attrs"
            v-on="$listeners"
            single-line
            hide-details
            :clearable="((clearable && !condensed) || search || allowClear) ? true : false"
            clear-icon="mdi-close-circle"
            :disabled="disabled"
            :prepend-inner-icon="search ? 'mdi-magnify' : prependInnerIcon"
            :menu-props="{
                contentClass: 'hb-autocomplete-menu'
            }"
            :rounded="rounded"
            :outlined="rounded || box || search"
            :dense="rounded || box || search"
            :class="{'hb-autocomplete-rounded' : rounded || box || search, 'hb-autocomplete-condensed' : condensed, 'hb-autocomplete-small' : small, 'hb-autocomplete-medium' : medium}"
            :background-color="backgroundColor"
        >
            <template v-for="(_, scopedSlot) in $scopedSlots" v-slot:[scopedSlot]="slotData">
                <slot :name="scopedSlot" v-bind="slotData"/>
            </template>
            <template v-for="(_, slot) in $slots" v-slot:[slot]>
                <slot :name="slot"/>
            </template>
            <template v-slot:progress>
                <v-progress-circular indeterminate size="18" :style="condensed && (box || rounded || search) ? 'margin-top: 12px;' : box || rounded || search ? 'margin-top: 11px;' : 'margin-top: -3px;'" class="mb-0 pa-0 ml-3 mr-0" color="#00848E" width="2"></v-progress-circular>
            </template>
        </v-autocomplete>
    </div>
</template>

<script type="text/babel">

export default {
    name:'HbAutocomplete',
    data(){
        return {

        }
    },
    computed: {
        /*
        autocomplete: {
            get () {
                return this.$attrs.value
            },
            set (value) {
                this.$emit('input', value)
            }
        }
        */
       computedWidth() {
            if(this.small) {
               return '60px';
            }
            else if(this.medium) {
                return '108px';
            } else if(this.width) {
                return this.width
            } else {
                return 'auto';
            }
       }
    },
    props: {
        value: {

        },
        full: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: true
        },
        rounded: {
            type: Boolean,
            default: false
        },
        box: {
            type: Boolean,
            default: false
        },
        search: {
            type: Boolean,
            default: false
        },
        prependInnerIcon: {
            type: String,
            default: undefined
        },
        disabled: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: undefined
        },
        condensed: {
            type: Boolean,
            default: undefined
        },
        small: {
            type: Boolean,
            default: false
        },
        medium: {
            type: Boolean,
            default: false
        },
        allowClear: {
            type: Boolean,
            default: false
        },
        backgroundColor: {
            type: String,
            default: '#FFFFFF'
        }
    }
}
</script>

<style>

.hb-autocomplete-wrapper {
    margin-top: -1px;
}

.hb-autocomplete-wrapper * {
    font-size: 14px;
}

.hb-autocomplete-width-370 {
    max-width: 370px;
}

.hb-autocomplete-wrapper input, .hb-autocomplete-wrapper .v-input--is-label-select input {
    color: #101318 !important;
    font-size: 14px !important;
    padding-top: 0px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.hb-autocomplete-wrapper .hb-autocomplete-rounded:not(.hb-autocomplete-condensed) input {
    padding-top: 6px;
}

.hb-autocomplete-wrapper .v-select__selection {
    margin-top: 1px;
    padding-bottom: 2px !important;
}

.hb-autocomplete-wrapper .v-label {
    color: #637381 !important;
    top: 0;
    padding-bottom: 8px !important;
    font-size: 14px !important;
}

.hb-autocomplete-wrapper .v-input:not(.v-input--is-dirty) ::placeholder {
    color: #637381 !important;
    font-size: 14px !important;
    opacity: 1;
}

.hb-autocomplete-wrapper .v-input__icon--clear .v-icon {
    font-size: 16px !important;
    color: #C4CDD5 !important;
    padding-bottom: 10px;
}

.hb-autocomplete-wrapper .hb-autocomplete-rounded .v-input__icon--clear .v-icon {
    padding-bottom: 0;
}

.hb-autocomplete-wrapper .v-input__icon--clear .v-icon:hover {
    color: #637381 !important;
}

.hb-autocomplete-wrapper :not(.hb-autocomplete-condensed) .v-input__prepend-inner {
    margin-top: 3px;
}

.hb-autocomplete-wrapper .v-input__prepend-inner, .hb-autocomplete-wrapper .v-input__append-inner {
    color: #637381 !important;
}

.hb-autocomplete-wrapper .v-input__icon.v-input__icon--prepend-inner .v-icon, .hb-autocomplete-wrapper .v-input__icon.v-input__icon--prepend .v-icon, .hb-autocomplete-wrapper .v-input__icon.v-input__icon--append-outer .v-icon, .hb-autocomplete-wrapper .v-input__icon.v-input__icon--append .v-icon {
    color: #637381 !important;
    padding-bottom: 8px;
}

.hb-autocomplete-wrapper .v-select--is-menu-active .v-input__append-inner .v-icon {
    padding-bottom: 0;
    margin-bottom: 8px;
}

.hb-autocomplete-wrapper .v-select--is-menu-active .v-input__icon--clear .v-icon {
    margin-bottom: 10px;
}

.hb-autocomplete-wrapper .hb-autocomplete-rounded .v-input__icon.v-input__icon--prepend-inner .v-icon, .hb-autocomplete-wrapper .hb-autocomplete-rounded .v-input__icon.v-input__icon--prepend .v-icon, .hb-autocomplete-wrapper .hb-autocomplete-rounded .v-input__icon.v-input__icon--append-outer .v-icon, .hb-autocomplete-wrapper .hb-autocomplete-rounded .v-input__icon.v-input__icon--append .v-icon {
    padding-bottom: 0;
}

.hb-autocomplete-menu {
    box-shadow: 0px 8px 18px rgba(71, 84, 116, 0.2) !important;
}

.hb-autocomplete-menu .v-list-item {
    min-height: 40px !important;
    font-weight: 400 !important;
    font-size: 14px !important;
}

.hb-autocomplete-menu .v-list-item__title {
    color: #101318;
    font-weight: 400 !important;
    font-size: 14px !important;
}

.hb-autocomplete-wrapper >>> .v-input.error--text input, .hb-autocomplete-wrapper >>> .v-input.error--text label, .hb-aviary-form-row >>> .v-label.v-label--active.error--text, .hb-autocomplete-wrapper .v-input.v-text-field--placeholder.error--text ::placeholder {
  color: #FB4C4C !important;
}

.hb-autocomplete-wrapper .v-input__prepend-outer .v-input__icon .v-icon.error--text, .hb-autocomplete-wrapper .v-input__prepend-inner .v-input__icon .v-icon.error--text, .hb-autocomplete-wrapper .v-input__append-inner .v-input__icon .v-icon.error--text, .hb-autocomplete-wrapper .v-input__append-outer .v-input__icon .v-icon.error--text,  .hb-autocomplete-wrapper .error--text .v-input__append-inner, .hb-autocomplete-wrapper .error--text .v-input__prepend-inner {
    color: #FB4C4C !important;
}

.hb-autocomplete-wrapper .v-text-field:not(.error--text):hover > .v-input__control > .v-input__slot::before {
    border-color: #C4CDD5 !important;
}

.hb-autocomplete-wrapper .v-text-field:not(.error--text) > .v-input__control > .v-input__slot::before {
    border-color: #DFE3E8 !important;
}

.hb-autocomplete-wrapper fieldset {
    border-color: #DFE3E8;
    margin: 0;
}

.hb-autocomplete-menu .v-list-item__content {
    text-transform: none !important;
}

.hb-autocomplete-menu {
    margin-top: 2px;
}

.hb-autocomplete-menu .v-list-item--dense .v-list-item__title, .hb-autocomplete-menu .v-list-item--dense .v-list-item__subtitle, .hb-autocomplete-menu .v-list--dense .v-list-item .v-list-item__title, .hb-autocomplete-menu .v-list--dense .v-list-item .v-list-item__subtitle {
    line-height: 1.2rem;
}

.hb-autocomplete-wrapper input[disabled] {
    opacity: 1;
}

.hb-autocomplete-wrapper.hb-autocomplete-disabled {
    opacity: .3 !important;
}

.hb-autocomplete-wrapper .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner {
    color: #637381;
    margin-top: 12px;
}

.hb-autocomplete-wrapper .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner .v-icon {
    color: #637381;
    margin-bottom: 8px;
}

.hb-autocomplete-wrapper .hb-autocomplete-rounded .v-input__prepend-inner {
    padding-right: 4px;
}

.hb-autocomplete-wrapper .v-input__prepend-outer {
    margin-right: 5px !important;
}

.hb-autocomplete-wrapper .v-input__prepend-outer .v-icon {
    margin-bottom: -5px;
}

.hb-autocomplete-wrapper .hb-autocomplete-rounded:not(.hb-autocomplete-condensed) .v-input__prepend-inner {
    margin-top: 12px !important;
}

.hb-autocomplete-wrapper .hb-autocomplete-rounded:not(.hb-autocomplete-condensed) .v-input__prepend-inner .v-icon {
    margin-bottom: 7px !important;
}

.hb-autocomplete-wrapper .hb-autocomplete-rounded .v-input__prepend-outer .v-icon {
    margin-bottom: -15px;
}

.hb-autocomplete-wrapper .v-text-field--rounded .v-input__slot {
    padding: 0 12px 0 15px;
}

hb-autocomplete-wrapper .hb-autocomplete-condensed {
    margin-bottom: 5px !important;
}

.hb-autocomplete-wrapper .hb-autocomplete-condensed .v-input__slot {
    top: -5px;
    padding: 0 8px !important;
    min-height: 38px !important;
}

.hb-autocomplete-wrapper .hb-autocomplete-condensed fieldset {
    top: 0;
    padding: 0 2px;
}

.hb-autocomplete-wrapper .hb-autocomplete-condensed input {
    padding-bottom: 0 !important;
    position:relative;
    top: 1.5px;
}

.hb-autocomplete-wrapper .hb-autocomplete-condensed .v-input__prepend-inner, .hb-autocomplete-wrapper .hb-autocomplete-condensed .v-input__append-inner {
    margin-top: 13.5px !important;
}

.hb-autocomplete-wrapper .hb-autocomplete-condensed .v-input__prepend-inner .v-input__icon--prepend-inner {
    margin-top: -1.5px !important;
    min-width: 18px;
    width: 18px;
    height: 18px;
}

.hb-select-wrapper .hb-select-condensed .v-input__append-inner {
    padding-left: 0;
}

.hb-autocomplete-wrapper .hb-autocomplete-condensed .v-input__append-inner .v-input__icon--append {
    margin-top: 3px;
    min-width: 18px;
    width: 18px;
    height: 18px;
}

.hb-autocomplete-wrapper .hb-autocomplete-condensed .v-input__prepend-inner .v-input__icon--prepend-inner .v-icon, .hb-autocomplete-wrapper .hb-autocomplete-condensed .v-input__append-inner .v-input__icon--append .v-icon {
    font-size: 18px;
}

.hb-autocomplete-condensed-wrapper {
    margin-right: 8px;
}

.hb-autocomplete-condensed-wrapper .v-input--is-focused input {
    min-width: 0 !important;
}

.hb-autocomplete-wrapper .v-text-field:not(.error--text):not(.v-input--is-focused):not(.v-input--is-loading):hover fieldset {
    border-color: #C4CDD5 !important;
}

.hb-autocomplete-wrapper .v-text-field:not(.error--text):not(.v-input--is-focused):not(.v-input--is-loading) fieldset {
    border-color: #DFE3E8 !important;
}

</style>